//#region ng
import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  signal
} from '@angular/core';
//#endregion

//#region 3rd
import Fuse from 'fuse.js';
import {
  combineLatest,
  Observable,
  of,
  Subject,
} from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  switchMap
} from 'rxjs/operators';
//#endregion

//#region models
interface IVm {
  searchTerm: string;
  tipos: ITipoLojas[];
};
import { ITipoLojas } from '../../../_misc/_models/_interfaces/_cols';
import { FOCUS_TIMEOUT } from '../../../../_core/_misc/_models/consts';
import { TCorViewStyle } from '../../../../_core/_misc/_models/_types';
//#endregion

//#region services
import { TiposLojasService } from '../../../_ng/_services';
import { CorLoaderService } from '../../../../_core/_ng/_services';
//#endregion

@Component({
  selector: 'me-mat-tipos-lojas',
  templateUrl: './tipos-lojas.component.html',
  styleUrls: ['./tipos-lojas.component.scss']
})
export class MeMatTiposLojasComponent {
  //#region inputs
  // tipos
  #tipos: ITipoLojas[];
  get tipos(): ITipoLojas[] { return this.#tipos; }
  @Input({ required: true }) set tipos(val: ITipoLojas[]) {
    this.#tipos = !!val ? this.#tiposLojasServ.fixes(val) : [];
    this.searchTermAction$().next('');
    this.focus();
  }
  // idSelected
  @Input() idSelected: string = '';
  //#endregion

  //#region outputs
  @Output() click$ = new EventEmitter<ITipoLojas>();
  //#endregion

  //#region actions
  searchTermAction$ = signal<Subject<string>>(new Subject<string>()).asReadonly();
  //#endregion

  //#region publics
  vm$ = signal<Observable<IVm>>(null);
  //#endregion

  //#region privates
  #hits$: Observable<ITipoLojas[]>;
  //#endregion

  //#region events
  searchFocusEvent$ = signal<EventEmitter<boolean>>(new EventEmitter<boolean>()).asReadonly();
  //#endregion

  //#region injects
  #tiposLojasServ = inject(TiposLojasService);
  //#endregion

  //#region lifecycles
  ngOnInit() {
    this.#hits$ = this.searchTermAction$()
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap(
          (searchTerm: string) => {
            // console.log(searchTerm);

            // fuse-js
            if (!!searchTerm.trim()) {
              const FUSE: any = new Fuse(
                this.#tipos,
                {
                  includeScore: false,
                  keys: [
                    'nome',
                  ],
                  // minMatchCharLength: 3,
                }
              );
              const HITS: any[] = FUSE.search(searchTerm);
              // console.log(HITS);
              return of(
                this.#tiposLojasServ.fixes(
                  (HITS || [])
                    .map(h => h?.item as ITipoLojas)
                ) as ITipoLojas[]
              );
            } // if
            return of(this.#tiposLojasServ.fixes(this.#tipos) as ITipoLojas[]);
          }
        )
      );

    this.vm$.set(
      combineLatest([
        this.searchTermAction$().pipe(startWith('')),
        this.#hits$.pipe(startWith(this.#tipos)),
      ])
        .pipe(
          map(([searchTerm, hits,]) => {
            // console.log(this._lojas);
            // console.log(lojas);
            const VM: IVm = {
              tipos: hits || [],
              searchTerm,
            };
            // console.log(VM);
            return VM;
          }),
        )
    );
  }

  ngAfterViewInit() {
    this.focus();
  }
  //#endregion

  //#region functions
  tid_tip(index: any, item: ITipoLojas): string { return item?.id || ''; }

  focus() {
    setTimeout(
      () => { this.searchFocusEvent$().emit(true); },
      FOCUS_TIMEOUT
    );
  }
  //#endregion
}
